import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=4496dc43&scoped=true&"
import script from "./teachers.vue?vue&type=script&lang=js&"
export * from "./teachers.vue?vue&type=script&lang=js&"
import style0 from "./teachers.vue?vue&type=style&index=0&id=4496dc43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496dc43",
  null
  
)

export default component.exports